import { Link } from 'react-router-dom';
import { videoCategories, siteInfo } from '@/mocks/videos';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-100">
                  {siteInfo.name}
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                聚合红桃视频、樱桃视频、茄子视频、糖心视频等多平台高清资源，
                最新热播剧一站看全，流畅不卡顿。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4">
                <a href="#video-categories" className="hover:text-primary-400 transition-colors">视频分类</a>
              </h4>
              <div className="flex flex-col gap-2">
                {videoCategories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
                <Link to="/category/movie" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  最新电影
                </Link>
                <Link to="/category/tv-series" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  热门电视剧
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4">合作伙伴</h4>
              <div className="flex flex-col gap-2 text-sm text-background-400">
                <span>红桃视频</span>
                <span>樱桃视频</span>
                <span>茄子视频</span>
                <span>糖心视频</span>
                <span>榴莲视频</span>
                <span>桃子视频</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-800 gap-4">
            <p className="text-sm text-background-500">
              &copy; {currentYear} {siteInfo.name} 版权所有 | 本站内容均来自网络，仅供学习交流
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">服务条款</a>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}